import React, { useState } from "react";
import {  Link } from "react-router-dom";
import axios from "axios";
import API_URLS from "../config/apiConfig";
import swal from 'sweetalert';
import { ClipLoader } from "react-spinners";
import InlineEditorComponent from "../components/InlineEditorComponent";

const PageForm = ({ selectedPage, onUpdate }) => {
  const authToken = localStorage.getItem("token");
   // const navigate = useNavigate();
    const [removeExistingPhoto, setRemoveExistingPhoto] = useState(false);
    const [errors, setErrors] = useState({});   
    const [loading, setLoading] = useState(false);
    const [photo, setPhoto] = useState(null);
    const [pageData, setPageData] = useState(selectedPage);
 //  console.log(pageData);
 
   const handleMediaChange = (e) => {
    const selectedValue = e.target.value;
   
   
    setPageData((prevData) => ({
        ...prevData,
        media_type: selectedValue,
    }));
};
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPageData({ ...pageData, [name]: value });
  };

  const handleDescriptionChange = (value) => {
    setPageData((prevData) => ({
        ...prevData,
        description: value, // Update description
    }));
};

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
     setPhoto(URL.createObjectURL(file));
     setPageData({ ...pageData, image: URL.createObjectURL(file) });
     setRemoveExistingPhoto(false);
  }
};

const handleRemoveImage = () => {
  setPhoto(null); // Clear preview
  pageData.uploaded_file_url=null;
  setPageData((prevData) => ({
    ...prevData,
    photo: null,
  }));
  setRemoveExistingPhoto(true); // Mark existing image for removal
};
  const validate = () => {
    const newErrors = {};
   
   if (!pageData.title.trim()){ newErrors.title = "Please enter title";}
   return newErrors;
   };
  const handleFormSubmit = async(e) => {
    e.preventDefault();
   // onSubmit(pageData);

   const validationErrors = validate();
   if (Object.keys(validationErrors).length > 0) {
     setErrors(validationErrors);
     return;
   }
   setLoading(true);
   try {
   const data = new FormData();
   data.append('id', pageData.id);
   data.append('course_id', pageData.course_id);
   data.append('chapter_id', pageData.chapter_id);
   data.append('title', pageData.title);
   data.append('page_number', pageData.page_number);
   data.append('description', pageData.description);
   data.append('media_type', pageData.media_type);
   data.append('iframe', pageData.iframe);
   data.append('remove_photo', removeExistingPhoto ? 1 : 0); 
   if(photo){
     const fileInput = document.querySelector('input[type="file"]');
     data.append('photo', fileInput.files[0]);
   }
   //console.log(data);
   const response = await axios.post(API_URLS.PAGE_SAVE, data,{
       headers: {
         Authorization: `Bearer ${authToken}`,
         'Content-Type': 'multipart/form-data'
       },
     });
     if(response.data.success==1){
     swal("Success", response.data.message, "success").then(() => {
       //navigate(`/manager/course-chapter?course_id=${pageData.course_id}`); // Redirect to the target page
      // window.location.reload();
       onUpdate();
       setPageData(response.data.pageData);
       // Clear the file field
    
     });
    
     }else{
     swal("Error", response.data.message, "error");  
     }
     
    // console.log(response.data); // Handle response
   } catch (error) {
     swal("Error", "Please try again.", "error");  
     console.error("Error:", error.response?.data || error.message);
   }finally {
     setLoading(false); 
   }
 };

  return (
     <>    
         {loading && (
                        <div className="loader-overlay">
                            <ClipLoader color="#08A9E6" loading={loading} size={50} />
                        </div>
                    )}
    <div className="col-md-8">
      <form name="pagefrm" onSubmit={handleFormSubmit}>
        <h3>Edit Page</h3>
        <div className="form-group">
          <label>Page Title</label>
          <input
            type="text"
            name="title"
            className="form-control"
            value={pageData.title || ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group" style={{display:'none'}}>
          <label>Page Number</label>
          <input
            type="text"
            name="page_number"
            className="form-control"
            value={pageData.page_number || ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <label>Content</label>
          <InlineEditorComponent name="description"
                    value={pageData.description || ""}
                    onChange={handleDescriptionChange} 
                /> 
          
          {errors.description && <p style={{ color: "red" }}>{errors.description}</p>}
                
        </div>
        <div className="form-group mt-1">
          <label>Upload Media</label>
          <div className="ms-2 form-check form-check-inline">
          <input className="form-check-input" type="radio" name="media_type" id="inlineRadio1" value="Image" checked={pageData.media_type === "Image"} onChange={handleMediaChange} />
          <label className="form-check-label" htmlFor="inlineRadio1">Image</label>
         </div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="media_type" id="inlineRadio2" value="Audio" checked={pageData.media_type === "Audio"} onChange={handleMediaChange}/>
          <label className="form-check-label" htmlFor="inlineRadio2">Audio</label>
        </div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="media_type" id="inlineRadio3" value="Video" checked={pageData.media_type === "Video"} onChange={handleMediaChange}/>
          <label className="form-check-label" htmlFor="inlineRadio3">Video</label>
        </div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="media_type" id="inlineRadio4" value="Presentation/Document" checked={pageData.media_type=== "Presentation/Document"} onChange={handleMediaChange}/>
          <label className="form-check-label" htmlFor="inlineRadio4">Presentation/Document</label>
        </div>
        <div className="form-check form-check-inline">
          <input className="form-check-input" type="radio" name="media_type" id="inlineRadio5" value="Iframe" checked={pageData.media_type === "Iframe"} onChange={handleMediaChange}/>
          <label className="form-check-label" htmlFor="inlineRadio5">Iframe</label>
        </div>
        
          <br/>
          {pageData.media_type!=='Iframe' && (
          <input
                    type="file"
                   
                    onChange={handleImageChange}
                /> )}
              
                 {pageData.uploaded_file_url  && pageData.media_type!=='Iframe' && (
                    <div>
                       
                        <Link to={pageData.uploaded_file_url} target="_blank" >View Media</Link>
                        <span onClick={handleRemoveImage} title="Remove Media"><i className="fa fa-trash ms-3"></i></span>
                    </div>
                )}
              {pageData.media_type==='Iframe' && (
              <div className="form-group mt-1">
              <label>Iframe</label>
              <textarea name="iframe" className="form-control" onChange={handleInputChange} value={pageData.iframe || ""}></textarea></div>
              )}
        </div>
         <div className="row">
            <div className="col-lg-12 col-md-12 mt-3 mb-5">
            <button type="submit" className="default-btn" disabled={loading}>
             {loading ? "Submitting..." : "Submit"}
             </button>                                                                          
              </div>
         </div>
      </form>
    </div>
    </>   
  );
};

export default PageForm;
